import { render, staticRenderFns } from "./FlashExpressForm.vue?vue&type=template&id=f5212858&"
import script from "./FlashExpressForm.vue?vue&type=script&lang=js&"
export * from "./FlashExpressForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports